module.exports = __webpack_public_path__ + "img/exp5.da713e93.png";